import { LangCodes } from '@tsl-frontend/tsl-locale';

import { enGBAppConfig, enUSAppConfig } from './lang';

export const appConfigRegistry = {
    [LangCodes.GB]: enGBAppConfig,
    [LangCodes.US]: enUSAppConfig,
} as const;
